import type { DailyPlan } from '../types';

export function exportDailyViewCsv(dailyPlan: DailyPlan, horizon: number): void {
  const days = (dailyPlan.days ?? []).filter((d) => d.day <= horizon);
  const windows = (dailyPlan.windows ?? []).filter((w) => w.windowStart <= horizon);
  if (!days.length) return;

  const headers = [
    'Day',
    'Leads Loaded',
    'Cumulative Leads',
    'Onboarding Emails',
    'Follow-up Emails',
    'Total Demand',
    'Fleet Capacity',
    'Usable Capacity (80%)',
    'Slots Allocated',
    'Utilisation % (of usable)',
    'Cumulative Slots',
    'Addresses Active',
    'Is Ramp End',
    'Is New Leads Start',
    'Is New Address Day',
  ];
  const rows: (string | number)[][] = days.map((d) => [
    d.day,
    d.onboardToday,
    d.cumLeads,
    d.onboardToday,
    d.followUpToday,
    d.demandToday,
    d.fleetCap,
    d.usableCap,
    d.slotsAllocated,
    d.utilPct,
    d.cumEmails,
    d.addrCount,
    d.isRampEnd ? 'Yes' : 'No',
    d.isNewStart ? 'Yes' : 'No',
    d.isAddrDay ? 'Yes' : 'No',
  ]);

  const summaryBlock: (string | number)[][] = [
    [],
    ['--- 10-DAY CUMULATIVE SUMMARY ---'],
    [
      'Period',
      'Leads Loaded (window)',
      'Cumulative Leads',
      'Slots Allocated (window)',
      'Cumulative Slots',
      'Avg Email Capacity/day',
    ],
    ...windows.map((w) => [
      `Days ${w.windowStart}-${w.windowEnd}`,
      w.windowLeads,
      w.cumLeads,
      w.windowSlots,
      w.cumSlots,
      w.avgCap,
    ]),
  ];

  const csv = [[...headers], ...rows, ...summaryBlock]
    .map((r) =>
      r
        .map((cell) => {
          const s = String(cell);
          return s.includes(',') || s.includes('"') || s.includes('\n')
            ? `"${s.replace(/"/g, '""')}"`
            : s;
        })
        .join(','),
    )
    .join('\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `nurturing_daily_view_${horizon}days.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
